import { latestUpdates } from '@/mocks/mangaData';

export default function LatestUpdates() {
  const typeLabels: Record<string, string> = {
    regular: '连载',
    gaiden: '外传',
    completed: '完结',
    special: '特别',
  };

  const typeColors: Record<string, string> = {
    regular: 'bg-primary-100 text-primary-700',
    gaiden: 'bg-accent-100 text-accent-800',
    completed: 'bg-secondary-100 text-secondary-700',
    special: 'bg-secondary-100 text-secondary-700',
  };

  return (
    <div className="space-y-2">
      {latestUpdates.map((item) => (
        <Link
          key={item.id}
          to={`/article/${item.mangaId}`}
          className="flex items-center gap-3 md:gap-4 p-3 rounded-lg hover:bg-background-100 transition-colors group cursor-pointer"
        >
          <span className={`shrink-0 px-2 py-0.5 rounded-md text-[11px] font-medium whitespace-nowrap ${typeColors[item.type] || typeColors.regular}`}>
            {typeLabels[item.type] || '连载'}
          </span>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
              {item.mangaTitle} {item.chapter}
            </p>
            <p className="text-xs text-foreground-500 truncate mt-0.5">{item.title}</p>
          </div>
          <span className="text-xs text-foreground-400 shrink-0 whitespace-nowrap">{item.date}</span>
          <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors shrink-0"></i>
        </Link>
      ))}
    </div>
  );
}